import React from "react";
import { SnackbarContent } from "notistack";
import { NotificationCard } from "../NotificationCard/NotificationCard";

export const CustomNotification = React.forwardRef((props, ref) => {
  const {
    notificationData,
    id,
    message,
    persist,
    preventDuplicate,
    variant,
    anchorOrigin,
    autoHideDuration,
    hideIconVariant,
    iconVariant,
    dense,
    action,
    ...other
  } = props;

  if (!notificationData) {
    return (
      <SnackbarContent ref={ref} role="alert" {...other}>
        {message}
      </SnackbarContent>
    );
  }

  return (
    <SnackbarContent
      ref={ref}
      role="alert"
      {...other}
      style={{
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        overflow: "hidden",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        ...other.style,
      }}
    >
      <NotificationCard
        idNotificacionUsuario={notificationData.idNotificacionUsuario}
        icon={notificationData.icon}
        icono={notificationData.icono}
        titulo={notificationData.titulo}
        descripcion={notificationData.descripcion}
        time={notificationData.time}
        isRecent={notificationData.isRecent}
      />
    </SnackbarContent>
  );
});

CustomNotification.displayName = "CustomNotification";
